import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';

/**
 * Picture
 */

const Picture = ({ picture, alt, legend }) => {
  const Tag = legend ? 'figure' : 'div';
  return (
    <Tag className="slide-picture">
      {legend && <figcaption dangerouslySetInnerHTML={{ __html: legend }} className="legend" />}
      <img src={picture} alt={alt} />
    </Tag>
  );
};

/**
 * SlidePicture
 */

class SlidePicture extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    this.open = () => this.setState({ isOpen: true });
    this.close = () => this.setState({ isOpen: false });
    this.closed = () => !this.state.isOpen;
    this.toggleOpenClose = () => this.setState({ isOpen: !this.state.isOpen });

    /** State */
    this.state = { isOpen: false };

    /** Refs */
    this.element = React.createRef();
  }

  render() {
    const zoomClass = this.props.pictureZoom ? 'l-hover-zoom' : '';
    return (
      <div ref={this.element} className="slide-picture-wrapper">
        {this.props.lightbox ? (
          <>
            <a
              className={`slide-picture-lightbox ${zoomClass}`}
              href={this.props.lightbox}
              onClick={(event) => {
                event.preventDefault();
                this.open();
              }}
            >
              <Picture picture={this.props.picture} alt={this.props.alt} legend={this.props.legend} />
            </a>
            {this.state.isOpen && <Lightbox mainSrc={this.props.lightbox} onCloseRequest={() => this.close()} />}
          </>
        ) : (
          <Picture picture={this.props.picture} alt={this.props.alt} legend={this.props.legend} />
        )}
      </div>
    );
  }
}

Picture.propTypes = {
  picture: PropTypes.string.isRequired,
  alt: PropTypes.string,
  legend: PropTypes.string,
};

SlidePicture.propTypes = {
  picture: PropTypes.string.isRequired,
  alt: PropTypes.string,
  legend: PropTypes.string,
  lightbox: PropTypes.string,
  pictureZoom: PropTypes.bool,
};

export default SlidePicture;
